import React, { useEffect, useState } from 'react';
import { generateToken } from '../notifications/firebase';

const NotificationPermissionModal = ({ isOpen, onClose, onAllow }) => {
    const [isClosing, setIsClosing] = useState(false);

    useEffect(() => {
        if (!isOpen) {
            setIsClosing(false);
        }
    }, [isOpen]);

    const handleAllow = async () => {
        setIsClosing(true);
        setTimeout(async () => {
            // Request permission via generateToken
            await generateToken();
            if (onAllow) onAllow();
            onClose();
        }, 300);
    };

    const handleDeny = () => {
        setIsClosing(true);
        setTimeout(() => {
            onClose();
        }, 300);
    };

    if (!isOpen && !isClosing) return null;

    return (
        <div className={`fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm transition-opacity duration-300 ${isClosing ? 'opacity-0' : 'opacity-100'}`}>
            <div className={`bg-gray-900 border-2 border-yellow-500/50 rounded-2xl w-full max-w-sm p-6 shadow-2xl shadow-yellow-500/10 transform transition-all duration-300 ${isClosing ? 'scale-90 opacity-0' : 'scale-100 opacity-100'}`}>

                <div className="text-center mb-6">
                    <div className="w-16 h-16 bg-yellow-500/10 rounded-full flex items-center justify-center mx-auto mb-4 animate-bounce-slow">
                        <i className="ri-notification-badge-line text-3xl text-yellow-500"></i>
                    </div>
                    <h3 className="text-xl font-bold text-white mb-2">Enable Notifications?</h3>
                    <p className="text-gray-400 text-sm leading-relaxed">
                        We notify only about <span className="text-yellow-400 font-semibold">Match Results</span>, <span className="text-green-400 font-semibold">Withdrawals</span>, and <span className="text-blue-400 font-semibold">Room IDs</span>.
                    </p>
                    <p className="text-gray-500 text-xs mt-2 font-medium bg-gray-800 py-1 px-2 rounded-full inline-block">
                        <i className="ri-shield-check-line mr-1 align-middle"></i>
                        No Spam. 100% Useful.
                    </p>
                </div>

                <div className="flex space-x-3">
                    <button
                        onClick={handleDeny}
                        className="flex-1 py-3 px-4 bg-gray-800 hover:bg-gray-700 text-gray-400 rounded-xl font-semibold transition-colors text-sm"
                    >
                        Maybe Later
                    </button>
                    <button
                        onClick={handleAllow}
                        className="flex-1 py-3 px-4 bg-gradient-to-r from-yellow-500 to-orange-500 hover:from-yellow-400 hover:to-orange-400 text-black rounded-xl font-bold shadow-lg shadow-yellow-500/20 transition-all transform active:scale-95 text-sm"
                    >
                        Allow Access
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NotificationPermissionModal;
